import React, { SyntheticEvent } from "react";
import { Close as CloseIcon } from "@mui/icons-material";
import { Box, Chip } from "@mui/material";
import { withStyles } from "@mui/styles";
import { colors, fontFamilies } from "~/theme";

const StyledChip = withStyles({
    root: {
        backgroundColor: colors.black80,
        borderRadius: "4px",
        margin: "3px",
        padding: "4px 0px 4px 8px",
        height: "auto",
    },
    label: {
        fontFamily: fontFamilies.hurme2,
        fontSize: "14px",
        lineHeight: "18px",
        color: colors.white70,
        whiteSpace: "normal",
    },
})(Chip);

function StopPropagation(e: SyntheticEvent) {
    e.nativeEvent.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
}

export function DropdownChip({
    selected,
    onDelete,
}: {
    selected: string;
    onDelete: (e: SyntheticEvent) => void;
}) {
    return (
        <StyledChip
            data-target="right-chip"
            label={selected}
            onDelete={onDelete}
            deleteIcon={
                <Box display="inline" color={`${colors.white70} !important`}>
                    <CloseIcon
                        onMouseDown={StopPropagation}
                        data-target="remove-right"
                        data-value={selected}
                    />
                </Box>
            }
        />
    );
}
